import { defineComponent as n, computed as l, openBlock as i, createElementBlock as r, createElementVNode as t, toDisplayString as d, createCommentVNode as h, normalizeStyle as f, createStaticVNode as m } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "d5f019a1-0318-4bc3-8a1e-83e71774c63b" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#d5f019a1-0318-4bc3-8a1e-83e71774c63b)" }, k = { key: 0 }, v = /* @__PURE__ */ m('<path fill="#0052b4" d="M448 0h64v512h-64l-16-256Z"></path><path fill="#eee" d="M416 0h32v512h-32l-16-256Z"></path><path fill="#d80027" d="M0 0h416v512H0z"></path><circle cx="208" cy="256" r="160" fill="#eee"></circle><circle cx="208" cy="256" r="128" fill="#0052b4"></circle><path fill="#eee" d="m145 284 60 83V265l-60 83 98-32zm15-128-22 100 76-68-102 11 89 51zm147 49-42 93-21-100 75 69-102-11z"></path>', 6), g = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ n({
  __name: "us-tn",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, o = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), a = l(() => 256 + e.strokeWidth / 2);
    return (y, w) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", u, [
        e.flagName ? (i(), r("title", k, d(e.flagName), 1)) : h("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, p));
  }
});
export {
  z as default
};
//# sourceMappingURL=us-tn-69fc6457.js.map
